
import React from "react";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import strings from '../../Globalization';
import { CIResultForm } from '../../AppGrid/CIResultTable';


const CIResultFormDialog = ({ data, open, onDismiss, onRefresh }) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const handleOnSetActiveRecord = (record, opts = { refresh: true }) => {
        if (typeof onDismiss === 'function') {
			onDismiss();
		}
        if (opts.refresh && typeof onRefresh === 'function') {
			onRefresh();
		}
    };
    return (
		<Dialog open={open} onClose={onDismiss} sx={{ '& .MuiDialog-paper': { minWidth: '60vw' } }} fullScreen={fullScreen}>
			<DialogTitle>
				<Typography fontSize={'inherit'} fontWeight="inherit" color="inherit">
					{strings.CIResult}
				</Typography>
			</DialogTitle>
			<DialogContent>
				<CIResultForm
					activeRecord={data}
					setActiveRecord={handleOnSetActiveRecord}
					containerProps={{ elevation: 0 }}
				/>
			</DialogContent>
		</Dialog>
	);
}

export default CIResultFormDialog;